import React, { memo } from 'react';
import { ZapIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-72">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-cyan-600/10 rounded-full blur-[150px] pointer-events-none" data-id="element-73" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-74">
        <div className="text-center mb-12" data-id="element-75">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-cyan-500/20 border border-cyan-400/30 text-cyan-400 mb-6 shadow-[0_0_30px_rgba(34,211,238,0.3)]" data-id="element-76">
            <ZapIcon className="w-8 h-8" data-id="element-77" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-50 mb-6" data-id="element-78">
            Presentamos el{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500" data-id="element-79">
              Método Cero Ruido
            </span>
          </h2>
        </div>

        <div className="bg-gradient-to-b from-white/10 to-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-80">
          <p className="text-xl md:text-2xl text-slate-200 leading-relaxed text-center mb-8 font-medium" data-id="element-81">
            No es un sistema de gestión de tiempo; es un protocolo de{' '}
            <span className="text-cyan-400 font-bold" data-id="element-82">Borrado Sensorial</span>.
          </p>

          <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-83">
            <p data-id="element-84">
              Basado en la técnica{' '}
              <em className="text-slate-100" data-id="element-85">The Sensory Clear</em>, este método
              no lucha contra tus distracciones, sino que vacía el "búfer" de tu
              memoria de trabajo en exactamente 5 minutos.
            </p>
            <div className="bg-cyan-950/30 border border-cyan-500/20 rounded-xl p-6" data-id="element-86">
              <p className="text-cyan-100" data-id="element-87">
                Al limpiar el ruido sensorial y cognitivo de forma física,
                permites que tu cerebro ejecutivo retome el mando sin
                resistencia.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}